"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require("react-intl");

var bedTypeDescriptions = (0, _reactIntl.defineMessages)({
    1: {
        "id": "formOptions.bedTypeDescriptions.1",
        "defaultMessage": "Individual single beds"
    },
    2: {
        "id": "formOptions.bedTypeDescriptions.2",
        "defaultMessage": "One double bed meant for two people"
    }
});

exports.default = bedTypeDescriptions;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/bed_type/bedTypeDescriptions.js
// module id = 1365
// module chunks = 0